import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Impressum = () => {
    return (
        <div style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            background: 'linear-gradient(135deg, #171B27 0%, #0F121C 100%)',
            color: '#edfaff',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Header */}
            <Header />

            {/* Content Wrapper */}
            <div style={{
                flex: '1',
                padding: '2rem 1rem',
                paddingTop: '120px'
            }}>
                {/* Content */}
                <div style={{
                    maxWidth: '800px',
                    margin: '0 auto 3rem',
                    background: '#242A3B',
                    borderRadius: '20px',
                    padding: 'clamp(2rem, 5vw, 3rem)',
                    border: '2px solid #30374A'
                }}>
                    <h2 style={{
                        fontSize: 'clamp(2rem, 4vw, 2.5rem)',
                        fontWeight: '700',
                        marginBottom: '2rem',
                        color: '#edfaff'
                    }}>Impressum</h2>

                    <div style={{ lineHeight: '1.8', color: '#596678' }}>
                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.3rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Angaben gemäß § 5 TMG</h3>
                            <p style={{ margin: '0.5rem 0' }}>
                                Alexander Beitz<br />
                                Hartengrube 58<br />
                                23552 Lübeck<br />
                                Deutschland
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.3rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Kontakt</h3>
                            <p style={{ margin: '0.5rem 0' }}>
                                E-Mail: <a href="mailto:alex@beitz.me" style={{
                                color: '#007AFF',
                                textDecoration: 'none'
                            }}>alex@beitz.me</a><br />
                                Telefon: <a href="tel:+491794156859" style={{
                                color: '#007AFF',
                                textDecoration: 'none'
                            }}>+49 179 4156859</a>
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.3rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
                            <p style={{ margin: '0.5rem 0' }}>
                                Alexander Beitz<br />
                                Hartengrube 58<br />
                                23552 Lübeck
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.3rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Haftungsausschluss</h3>

                            <h4 style={{
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Haftung für Inhalte</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                            </p>

                            <h4 style={{
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Haftung für Links</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                            </p>

                            <h4 style={{
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Urheberrecht</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                            </p>
                        </section>

                        <section style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #30374A' }}>
                            <p style={{ fontSize: '0.9rem', color: '#596678' }}>
                                Stand: Oktober 2025
                            </p>
                        </section>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Impressum;